import { Details } from "@tiptap-pro/extension-details";
import { DetailsSummary } from "@tiptap-pro/extension-details-summary";
import { DetailsContent } from "@tiptap-pro/extension-details-content";
import { type MarkdownSerializerState } from "prosemirror-markdown";
import { type Node as PMNode } from "@tiptap/pm/model";

const DetailsExtension = Details.extend({
  draggable: true,

  // Accordion can be set through either keyboard shortcut Cmd + >, the menu bar (when text is selected) or the slash command menu
  addKeyboardShortcuts() {
    return {
      "Mod-.": () => this.editor.commands.setDetails(), // Cmd + >
      Backspace: () => {
        const cursorPosition = this.editor.state.selection.$anchor;
        const nodeType = cursorPosition.parent?.type.name;

        // only unset accordion if cursor is at the beginning of the details summary node
        if (
          cursorPosition &&
          cursorPosition.parentOffset === 0 &&
          nodeType &&
          nodeType === "detailsSummary"
        ) {
          this.editor.commands.unsetDetails();
          return true;
        }
        return false;
      },
    };
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: PMNode) => {
          state.write("<details>\n");
          state.write("<summary>");
          if (node.firstChild && node.firstChild.type.name === "detailsSummary") {
            state.renderContent(node.firstChild);
          }
          state.write("</summary>\n");
          if (node.lastChild && node.lastChild.type.name === "detailsContent") {
            state.renderContent(node.lastChild);
          }
          state.write("</details>\n\n");
        },
      },
    };
  },
});

export const AccordionBlock = DetailsExtension.configure({
  persist: true,
  HTMLAttributes: {
    class:
      "accordion rounded-md flex my-1 p-2 toggle-button accordion-toggle-light dark:accordion-toggle-dark",
  },
});

export const AccordionSummary = DetailsSummary.configure({
  HTMLAttributes: {
    class: "list-none mt-0.5", // hide the default summary list marker
  },
});

export const AccordionContent = DetailsContent.configure({
  HTMLAttributes: {
    class: "accordion-content",
  },
});
